<template>
  <div id="main" v-if="user != null && configs != null && is_loading == false">
    <modal
      name="modal_payment_0"
      :adaptive="true"
      height="auto"
      :scrollable="true"
    >
      <div id="modal_payment_0_body" class="col">
        <div class="row">
          <div class="col aling-center">
            <span>Como seu cliente vai pagar o valor de {{ form_value }}?</span>
          </div>
        </div>
        <div class="row sized-top-20">
          <div class="col aling-center">
            <button type="button" class="btn btn-dark" v-on:click="payment1(1)">
              Dinheiro
            </button>
          </div>
          <div class="col aling-center">
            <button
              type="button"
              class="btn btn-secondary"
              v-on:click="payment1(2)"
            >
              Cartão
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal
      name="modal_payment_1"
      :adaptive="true"
      height="auto"
      :scrollable="true"
    >
      <div id="modal_payment_1_body" class="col">
        <div class="row">
          <div class="col aling-center">
            <span>Qual o método de pagamento do motorista?</span>
          </div>
        </div>
        <div class="row sized-top-20">
          <div class="col aling-center">
            <button type="button" class="btn btn-dark" v-on:click="payment2(0)">
              R${{ selectValue().toFixed(2) }} Dinheiro
            </button>
          </div>
          <div class="col aling-center">
            <button
              type="button"
              class="btn btn-secondary"
              v-on:click="payment2(2)"
            >
              R${{ selectValue().toFixed(2) }} Cashback
            </button>
          </div>
        </div>
        <div class="row sized-top-20">
          <div class="col aling-center">
            <span>Pedido no cashback não gera saldo</span>
          </div>
        </div>
        <div class="row">
          <div class="col aling-center">
            <span>Valores válidos para perímetro urbano</span>
          </div>
        </div>
      </div>
    </modal>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col" id="col_left">
            <div class="row">
              <div class="col aling-center">
                <span class="text-bold">Dados do seu endereço</span>
              </div>
            </div>
            <div class="row sized-top-20">
              <div class="col">
                <div class="form-group">
                  <label for="form_name">Seu nome:</label>
                  <input
                    v-model="form_name"
                    type="text"
                    class="form-control"
                    id="form_name"
                    aria-describedby="nameHelp"
                    placeholder="digite aqui"
                  />
                  <small
                    id="nameHelp"
                    v-bind:class="
                      (form_name == ''
                        ? 'text-muted'
                        : validateName(form_name)
                        ? 'text-success'
                        : 'text-danger') + ' form-text'
                    "
                    >*
                    {{
                      form_name == ''
                        ? 'Digite o seu nome'
                        : validateName(form_name)
                        ? 'Nome válido'
                        : 'Nome inválido'
                    }}</small
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label for="form_address">Seu endereço:</label>
                  <input
                    v-model="form_address"
                    type="text"
                    class="form-control"
                    id="form_address"
                    aria-describedby="addressHelp"
                    placeholder="digite aqui"
                    ref="form_address"
                  />
                  <small
                    id="addressHelp"
                    v-bind:class="
                      (form_address == ''
                        ? 'text-muted'
                        : validateAddress(form_address)
                        ? 'text-success'
                        : 'text-danger') + ' form-text'
                    "
                    >*
                    {{
                      form_address == ''
                        ? 'Digite o seu endereço'
                        : validateAddress(form_address)
                        ? 'Endereço válido'
                        : 'Endereço inválido'
                    }}</small
                  >
                </div>
              </div>
              <div class="col col_number">
                <div class="form-group">
                  <label for="form_number">Número:</label>
                  <input
                    v-model="form_number"
                    type="text"
                    class="form-control"
                    id="form_number"
                    aria-describedby="numberHelp"
                    placeholder="digite aqui"
                  />
                  <small
                    id="numberHelp"
                    v-bind:class="
                      (form_number == ''
                        ? 'text-muted'
                        : validateNumber(form_number)
                        ? 'text-success'
                        : 'text-danger') + ' form-text'
                    "
                    >*
                    {{
                      form_number == ''
                        ? 'Digite o número'
                        : validateNumber(form_number)
                        ? 'Número válido'
                        : 'Número inválido'
                    }}</small
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col aling-center">
                <span class="text-bold">Dados do destinatário</span>
              </div>
            </div>
            <div class="row sized-top-20">
              <div class="col">
                <div class="form-group">
                  <label for="form_destiny_phone">Telefone do cliente:</label>
                  <input
                    v-model="form_destiny_phone"
                    v-mask="'(##) #########'"
                    type="tel"
                    class="form-control"
                    id="form_destiny_phone"
                    aria-describedby="destinyPhoneHelp"
                    placeholder="digite aqui"
                  />
                  <small
                    id="destinyPhoneHelp"
                    v-bind:class="
                      (form_destiny_phone == ''
                        ? 'text-muted'
                        : validateDestinyPhone(form_destiny_phone)
                        ? 'text-success'
                        : 'text-danger') + ' form-text'
                    "
                    >*
                    {{
                      form_destiny_phone == ''
                        ? 'Digite o número do cliente'
                        : validateDestinyPhone(form_destiny_phone)
                        ? 'Telefone válido'
                        : 'Telefone inválido'
                    }}</small
                  >
                </div>
              </div>
            </div>
            <div v-if="destiny_load == false">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="form_destiny_name">Nome do cliente:</label>
                    <input
                      v-model="form_destiny_name"
                      type="text"
                      class="form-control"
                      id="form_destiny_name"
                      aria-describedby="destinyNameHelp"
                      placeholder="digite aqui"
                    />
                    <small
                      id="destinyNameHelp"
                      v-bind:class="
                        (form_destiny_name == ''
                          ? 'text-muted'
                          : validateDestinyName(form_destiny_name)
                          ? 'text-success'
                          : 'text-danger') + ' form-text'
                      "
                      >*
                      {{
                        form_destiny_name == ''
                          ? 'Digite o nome do cliente'
                          : validateDestinyName(form_destiny_name)
                          ? 'Nome válido'
                          : 'Nome inválido'
                      }}</small
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="form_destiny_address">Endereço:</label>
                    <input
                      v-model="form_destiny_address"
                      type="text"
                      class="form-control"
                      id="form_destiny_address"
                      aria-describedby="destinyAddressHelp"
                      placeholder="digite aqui"
                    />
                    <small
                      id="destinyAddressHelp"
                      v-bind:class="
                        (form_destiny_address == ''
                          ? 'text-muted'
                          : validateDestinyAddress(form_destiny_address)
                          ? 'text-success'
                          : 'text-danger') + ' form-text'
                      "
                      >*
                      {{
                        form_destiny_address == ''
                          ? 'Digite o endereço'
                          : validateDestinyAddress(form_destiny_address)
                          ? 'Endereço válido'
                          : 'Endereço inválido'
                      }}</small
                    >
                  </div>
                </div>
                <div class="col col_number">
                  <div class="form-group">
                    <label for="form_destiny_number">Número:</label>
                    <input
                      v-model="form_destiny_number"
                      type="text"
                      class="form-control"
                      id="form_destiny_number"
                      aria-describedby="destinyNumberHelp"
                      placeholder="digite aqui"
                    />
                    <small
                      id="destinyNumberHelp"
                      v-bind:class="
                        (form_destiny_number == ''
                          ? 'text-muted'
                          : validateDestinyNumber(form_destiny_number)
                          ? 'text-success'
                          : 'text-danger') + ' form-text'
                      "
                      >*
                      {{
                        form_destiny_number == ''
                          ? 'Digite o número'
                          : validateDestinyNumber(form_destiny_number)
                          ? 'Número válido'
                          : 'Número inválido'
                      }}</small
                    >
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="loader"></div>
            </div>
          </div>
          <div class="col" id="col_right">
            <div class="row">
              <div class="col aling-center">
                <span class="text-bold">Dados da entrega</span>
              </div>
            </div>
            <div class="row sized-top-20">
              <div class="col">
                <div class="form-group">
                  <label for="form_obs">Observação:</label>
                  <input
                    v-model="form_obs"
                    type="text"
                    class="form-control"
                    id="form_obs"
                    aria-describedby="obsHelp"
                    placeholder="digite aqui"
                  />
                  <small id="obsHelp" class="text-muted"
                    >Observação (Opcional)</small
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label for="form_oc">Ordem de compra:</label>
                  <input
                    v-model="form_oc"
                    type="text"
                    class="form-control"
                    id="form_oc"
                    aria-describedby="ocHelp"
                    placeholder="digite aqui"
                  />
                  <small id="ocHelp" class="text-muted"
                    >Ordem de compra (Opcional)</small
                  >
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label for="form_value">Valor da entrega:</label>
                  <input
                    v-model.lazy="form_value"
                    v-money="money"
                    type="tel"
                    class="form-control"
                    id="form_value"
                    aria-describedby="valueHelp"
                    placeholder="digite aqui"
                  />
                  <small id="valueHelp" class="text-muted"
                    >Valor da entrega (Opcional)</small
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col aling-center">
                <span class="text-bold">Configuração da entrega</span>
              </div>
            </div>
            <div class="row sized-top-20" v-if="drivers != null">
              <div class="col aling-center">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="form_driver"
                    v-model="form_driver"
                  />
                  <label class="form-check-label" for="form_driver"
                    >Desejo especificar o motorista</label
                  >
                </div>
              </div>
            </div>
            <div
              class="row sized-top-20"
              v-if="form_driver == true && drivers != null"
            >
              <div class="col">
                <div class="form-group">
                  <label for="form_drivers"
                    >Qual motorista está levando sua entrega?</label
                  >
                  <select
                    class="form-control"
                    v-model="form_drivers"
                    aria-describedby="countHelp"
                  >
                    <option v-for="driver in drivers" :key="driver">
                      {{ driver }}
                    </option>
                  </select>
                  <small id="countHelp" class="text-muted" for="form_drivers"
                    >* Selecione o motorista</small
                  >
                </div>
              </div>
            </div>
            <div class="row sized-top-20" v-if="form_driver == false">
              <div class="col">
                <div class="form-group">
                  <label for="form_count">Quantas motos você deseja?</label>
                  <select
                    class="form-control"
                    v-model="form_count"
                    aria-describedby="countHelp"
                  >
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                  </select>
                  <small id="countHelp" class="text-muted" for="form_count"
                    >* Selecione a quantidade</small
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row sized-top-20" v-if="form_address_key == null">
          <div class="col aling-center">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="form_save"
                v-model="form_save"
              />
              <label class="form-check-label" for="form_save"
                >Salvar endereço</label
              >
            </div>
          </div>
        </div>
        <div class="row sized-top-20">
          <div class="col aling-center">
            <button
              type="button"
              class="btn btn-dark"
              v-bind:disabled="validate()"
              v-on:click="payment0()"
            >
              Solicitar entrega
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="sized-top-10" v-if="adresses != null">
      <div class="row sized-top-20">
        <div class="col aling-center">
          <span class="text-bold">Meus endereços favoritos</span>
        </div>
      </div>
      <div
        class="row sized-top-20"
        v-for="address in adresses"
        :key="address.key"
      >
        <div class="col">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  {{ address.data.address.description.toUpperCase() }},
                  {{ address.data.address.number.toUpperCase() }}
                </div>
                <div class="col-md-auto">
                  <button
                    type="button"
                    class="btn btn-dark mobile"
                    onclick="return false;"
                    v-on:click="setAddress(address)"
                  >
                    Usar endereço
                  </button>
                </div>
                <div class="col-md-auto">
                  <div class="dropdown">
                    <button
                      class="btn btn-secondary dropdown-toggle mobile"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Opções
                    </button>
                    <div class="dropdown-menu">
                      <a
                        class="dropdown-item"
                        href="#"
                        onclick="return false;"
                        v-on:click="deleteAddress(address)"
                        >Excluir endereço</a
                      >
                      <a
                        class="dropdown-item"
                        href="#"
                        onclick="return false;"
                        v-on:click="setDefaultAddress(address)"
                        v-if="form_address_default_key != address.key"
                        >Usar como principal</a
                      >
                      <a
                        class="dropdown-item"
                        href="#"
                        onclick="return false;"
                        v-on:click="removeDefaultAddress()"
                        v-else
                        >Remover do principal</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="sized-top-20" v-else>
    <div class="loader"></div>
  </div>
</template>

<script>
import { VMoney } from 'v-money';
import { db, functions } from '../configs/firebase.js';

export default {
  name: 'Main',
  data() {
    return {
      is_loading: false,
      destiny_load: false,
      form_driver: false,
      form_drivers: null,
      form_name: '',
      form_name_valid: '',
      form_address: '',
      form_address_valid: '',
      form_number: '',
      form_number_valid: '',
      form_destiny_key: null,
      form_destiny_phone: '',
      form_destiny_phone_valid: '',
      form_destiny_name: '',
      form_destiny_name_valid: '',
      form_destiny_address: '',
      form_destiny_address_valid: '',
      form_destiny_number: '',
      form_destiny_number_valid: '',
      form_obs: '',
      form_oc: '',
      form_value: '',
      form_value_valid: 0.0,
      form_value_type: 0,
      form_count: '1',
      form_save: false,
      form_address_key: null,
      form_address_default_key: null,
      money: {
        decimal: '.',
        thousands: '',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true
      },
      adresses: null,
      phone_back: null
    };
  },
  directives: { money: VMoney },
  methods: {
    validateName(name) {
      if (name.length > 3) {
        this.form_name_valid = name;
        return true;
      }
      this.form_name_valid = '';
      return false;
    },
    validateAddress(address) {
      if (address.length > 3) {
        this.form_address_valid = address;
        return true;
      }
      this.form_address_valid = '';
      return false;
    },
    validateNumber(number) {
      if (number.length > 1) {
        this.form_number_valid = number;
        return true;
      }
      this.form_number_valid = '';
      return false;
    },
    validateDestinyPhone(phone) {
      let x = phone.replace(/[^0-9]+/g, '');
      if (x.length >= 10) {
        if (x.substring(2, 3) != '9' || x.length == 11) {
          if (x != this.phone_back) {
            this.phone_back = x;
            this.getDestiny(x);
          }
        }
        this.form_destiny_phone_valid = x;
        return true;
      }
      this.form_destiny_phone_valid = '';
      return false;
    },
    validateDestinyName(name) {
      if (name.length > 1) {
        this.form_destiny_name_valid = name;
        return true;
      }
      this.form_destiny_name_valid = '';
      return false;
    },
    validateDestinyAddress(address) {
      if (address.length > 3) {
        this.form_destiny_address_valid = address;
        return true;
      }
      this.form_destiny_address_valid = '';
      return false;
    },
    validateDestinyNumber(number) {
      if (number.length > 1) {
        this.form_destiny_number_valid = number;
        return true;
      }
      this.form_destiny_number_valid = '';
      return false;
    },
    validate() {
      if (
        this.form_destiny_phone_valid.length > 0 &&
        this.form_destiny_address_valid.length > 0 &&
        this.form_destiny_number_valid.length > 0 &&
        this.form_destiny_name_valid.length > 0 &&
        this.form_destiny_key == null
      ) {
        this.form_destiny_key = 'save';
      }

      if (
        this.form_name_valid.length > 0 &&
        this.form_address_valid.length > 0 &&
        this.form_number_valid.length > 0
      ) {
        if (this.form_driver) {
          if (this.form_drivers != null) {
            return false;
          } else {
            return true;
          }
        }

        return false;
      }
      return true;
    },
    async getDestiny(phone) {
      try {
        this.destiny_load = true;

        this.form_destiny_key = null;
        this.form_destiny_name = '';
        this.form_destiny_address = '';
        this.form_destiny_number = '';

        let q_destiny = await db
          .ref('destiny_adresses')
          .orderByChild('keys/user_phone')
          .equalTo(this.user.uid + '|' + phone)
          .once('value');

        let destiny;

        q_destiny.forEach((s_destiny) => {
          destiny = {
            key: s_destiny.key,
            data: s_destiny.val()
          };
        });

        if (destiny != null) {
          this.form_destiny_key = destiny.key;
          this.form_destiny_name = destiny.data.address.name;
          this.form_destiny_address = destiny.data.address.description;
          this.form_destiny_number = destiny.data.address.number;
        }
      } catch (e) {
        //console.log(e);
      } finally {
        this.destiny_load = false;
      }
    },
    async deleteAddress(address) {
      try {
        await db.ref('adresses/' + address.key).remove();
        this.adresses = this.adresses.filter((x) => x.key != address.key);
      } catch (e) {
        //console.log(e);
      }
    },
    async setDefaultAddress(address) {
      try {
        await db.ref('users/' + this.user.uid + '/address').transaction((x) => {
          x = address.key;
          return x;
        });

        this.form_address_default_key = address.key;
        this.setAddress(address);

        alert('Parabéns, esse endereço é seu novo endereço principal');
      } catch (e) {
        //console.log(e);
      }
    },
    async removeDefaultAddress() {
      try {
        await db.ref('users/' + this.user.uid + '/address').remove();

        let address = {
          key: null,
          data: {
            address: {
              description: '',
              number: ''
            }
          }
        };

        this.form_address_default_key = null;
        this.setAddress(address);

        alert('Você removeu o endereço do principal');
      } catch (e) {
        //console.log(e);
      }
    },
    setAddress(address) {
      this.form_save = false;
      this.form_address_key = address.key;
      this.form_address = address.data.address.description;
      this.form_number = address.data.address.number;
      this.$refs.form_address.focus();
    },
    async getAdresses() {
      try {
        let q_adresses = await db
          .ref('adresses')
          .orderByChild('keys/user_click')
          .startAt(this.user.uid + '|')
          .endAt(this.user.uid + '|\uf8ff')
          .limitToLast(30)
          .once('value');

        let x = [];

        q_adresses.forEach((s_address) => {
          let address = {
            key: s_address.key,
            data: s_address.val()
          };

          x.push(address);
        });

        if (x.length > 0) {
          this.adresses = x;
        }
      } catch (e) {
        //console.log(e);
      }
    },
    selectValue() {
      try {
        if (this.user_data.fixed != null && this.user_data.fixed != undefined) {
          return this.user_data.fixed;
        }

        let price = this.configs.price;

        let value = 0;
        let meters = 0;

        for (const [k, v] of Object.entries(price)) {
          if (v.meters <= this.configs.distance_web && v.meters >= meters) {
            value = v.value;
            meters = v.meters;
          }
        }

        let period = this.configs.period;

        if (period == 1) {
          value = value + this.configs.addition;
        } else if (period == 2) {
          value = value + this.configs.special;
        }

        return value;
      } catch (e) {
        //console.log(e);
        return this.configs.value;
      }
    },
    payment0() {
      this.form_value_valid = parseFloat(this.form_value.replace('R$ ', ''));

      if (this.form_value_valid > 0.05) {
        this.$modal.show('modal_payment_0');
      } else {
        this.payment1(0);
      }
    },
    payment1(type) {
      this.form_value_type = type;

      if (type > 0) {
        this.$modal.hide('modal_payment_0');
      }

      this.$modal.show('modal_payment_1');
    },
    async payment2(payment) {
      this.$modal.hide('modal_payment_1');

      let payload = {
        save: this.form_save,
        name: this.form_name_valid.trim(),
        address: this.form_address_valid.trim(),
        number: this.form_number_valid.trim(),
        destiny: this.form_destiny_address_valid.trim(),
        obs: this.form_obs.trim(),
        value: this.selectValue(),
        valuePay: this.form_value_valid,
        count: parseInt(this.form_count),
        payment: payment,
        addressKey: this.form_address_key,
        oc: this.form_oc.trim(),
        clientPhone: this.form_destiny_phone_valid,
        clientName: this.form_destiny_name_valid,
        clientNumber: this.form_destiny_number_valid,
        clientKey: this.form_destiny_key,
        payMethod: this.form_value_type > 0 ? this.form_value_type - 1 : 0
      };

      if (this.form_driver && this.form_drivers != null) {
        payload['driver'] = this.form_drivers;
      }

      this.is_loading = true;

      let sendTravel_onCall = functions.httpsCallable('sendTravel_onCall');
      let result = await sendTravel_onCall(payload);

      let errorMessage;

      switch (result.data) {
        case 0:
          errorMessage =
            'Erro na comunicação, verifique sua conexão de internet';
          break;
        case 1:
          errorMessage =
            'Não conseguimos obter sua localização, veririfique se está ativada';
          break;
        case 2:
          errorMessage =
            'Erro de autenticação, verifique a sua sessão de login';
          break;
        case 3:
          errorMessage = 'Você não tem saldo suficiente na carteira';
          break;
        case 4:
          errorMessage = 'Ocorreu um erro ao comunicar com a nossa central';
          break;
        case 5:
          errorMessage =
            'Sua entrega foi recebida pela nossa central com sucesso';
          break;
        case 6:
          errorMessage = 'Erro interno do servidor, comunique o nosso suporte';
          break;
        default:
          errorMessage = 'Erro desconhecido, comunique o nosso suporte';
      }

      alert(errorMessage);

      if (result.data == 5) this.$router.push({ path: 'express' });

      this.is_loading = false;
    },
    initUserData() {
      try {
        this.getAdresses();
        if (this.user.displayName != null) {
          this.form_name = this.user.displayName;
        }
      } catch (e) {
        //console.log(e);
      }
    },
    initAdresses() {
      try {
        let address = this.adresses.find(
          (x) => x.key == this.user_data.address
        );

        if (address != null) {
          this.form_address_default_key = address.key;
          this.setAddress(address);
        }
      } catch (e) {
        //console.log(e);
      }
    },
    async getDrivers() {
      if (this.drivers == null) {
        let getDrivers_onCall = functions.httpsCallable('getDrivers_onCall');
        let result = await getDrivers_onCall();

        if (result.data != null) {
          this.$root.drivers = result.data;
        }
      }
    }
  },
  computed: {
    user: function () {
      return this.$root.user;
    },
    user_data: function () {
      return this.$root.user_data;
    },
    configs: function () {
      return this.$root.configs;
    },
    drivers: function () {
      return this.$root.drivers;
    }
  },
  watch: {
    user_data() {
      this.initUserData();
    },
    adresses() {
      this.initAdresses();
    }
  },
  created() {
    this.initUserData();
    this.initAdresses();
    this.getDrivers();
  }
};
</script>

<style>
#main {
  text-align: left;
  margin: 20px auto;
  max-width: 912px;
}

.col_number {
  max-width: 180px;
}

#modal_payment_0_body {
  margin: 10px;
  width: 100%;
}

#modal_payment_1_body {
  margin: 10px;
  width: 100%;
}

@media only screen and (max-width: 912px) {
  #main {
    width: 100%;
    padding: 0px;
  }

  .col_number {
    max-width: none;
  }

  #col_left {
    min-width: 230px;
  }
  #col_right {
    min-width: 230px;
  }
}
</style>
